export const mixin = {
  methods: {
    setAchorPoint (name) {
      if (document.querySelector(name)) {
        document.querySelector(name).scrollIntoView(true);
        document.querySelector(name).scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
      } 
    },
    getRouter () {
      if (this.isFocus) {
        return 'l'
      }
      return this._.get(this.$route, 'query.achorPoint', '')
    }
  },
  created () {
    const achorPoint = '#' + this.getRouter()
    this.$nextTick(() => {
      if (!achorPoint) return 
      this.setAchorPoint(achorPoint)
    })
  }
}


// WEBPACK FOOTER //
// ./src/mixin/mixin.js